import { AccountClass } from "@common/constants/domains/accounting/accounts";
import {
    FORM_1099_BOX_SOURCES,
    Form1099Box,
} from "@common/constants/domains/accounting/form1099Box";
import { FinancialAccountType } from "@common/types/financialAccount";
import { z } from "zod";
import { accountSubtypeSchema, accountTypeSchema } from "./account.schema";

export const importedAccountSchema = z.object({
    id: z.string().uuid(),
    accountingMigrationId: z.string().uuid(),
    providerId: z.string(),
    name: z.string(),
    code: z.string().nullable(),
    providerType: z.string().nullable(),
    classification: z.nativeEnum(AccountClass),
    kickType: accountTypeSchema.nullable(),
    kickSubtype: accountSubtypeSchema.nullable(),
    form1099Box: z.nativeEnum(Form1099Box).nullable(),
    form1099BoxSource: z.enum(FORM_1099_BOX_SOURCES).nullable(),
    financialType: z.nativeEnum(FinancialAccountType).nullable(),
    cashOpeningBalance: z.number().nullable(),
    accrualOpeningBalance: z.number().nullable(),
    accountId: z.string().uuid().nullable(),
    pendingAccountId: z.string().uuid().nullable(),
    detectedInstitutionName: z.string().nullable(),
    accountConnectionTaskId: z.string().uuid().nullable(),
    createNewAccount: z.boolean(),
    requiresFinancialAccountMapping: z.boolean(),
    mappedFinancialAccountId: z.number().nullable(),
    financialAccountMappingFinishedAt: z.coerce.date().nullable(),
    isClosed: z.boolean(),
    isInactive: z.boolean(),
    importedAccountGroupId: z.string().uuid().nullable(),
    sortOrder: z.number(),
});

export type ImportedAccount = z.infer<typeof importedAccountSchema>;

export const bulkUpdateImportedAccountsBodySchema = z.object({
    updates: z
        .array(
            z.object({
                importedAccountId: z.string().uuid(),
                accountId: z.string().uuid().nullable().optional(),
                kickType: accountTypeSchema.nullable().optional(),
                createNewAccount: z.boolean().optional(),
                financialType: z
                    .nativeEnum(FinancialAccountType)
                    .nullable()
                    .optional(),
                mappedFinancialAccountId: z.number().nullable().optional(),
                isClosed: z.boolean().optional(),
            }),
        )
        .min(1),
});

export type BulkUpdateImportedAccountsBody = z.infer<
    typeof bulkUpdateImportedAccountsBodySchema
>;
